<template>
	<div v-if="loaded">
		<span v-if="count" class="challenge-friends-list">
			<span style="margin-right: 10px;">
				{{ count }}
				<span v-if="count > 1">
					{{ t.dashboardChallengesFriendsHaveDoneIt }}
				</span>
				<span v-else>
					{{ t.dashboardChallengesFriendHasDoneIt }}
				</span>
			</span>

			<span v-for="val in friends" :key="val.user_picture" class="friend-small-thumbnail">
				<UserThumbnail :image-url="val.user_picture" />
			</span>

			<span v-if="count > friends.length" class="friend-small-thumbnail more-friends-icon">
				<font-awesome-icon icon="plus" />
			</span>
		</span>

		<span v-else class="challenge-friends-list">
			{{ t.dashboardBeFirstOfYourFriends }}
		</span>
	</div>
</template>

<script setup>
import { computed, inject, onMounted, ref, watch } from "vue";
import { useStore } from '@/js/stores/index';
import { useUserStore } from "@/js/stores/user";
import UserThumbnail from "../blocks/user-thumbnail.vue";

const axios = inject('axios')
const store = useStore()
const userStore = useUserStore()

// Props
const props = defineProps({
	challengeId: {
		type: [Number, String],
		required: true,
	},
})

// Reactives
const friends = ref(null)
const count = ref(null)
const loaded = ref(false)

// Computeds
const t = computed(() => store.translations)
const connectionStatusFacebook = computed(() => userStore.connectionStatus.facebook)

// Watchers
watch(connectionStatusFacebook, val => {
	// Let's load friends if just connected
	if(val == 'connected'){
		loadFriends()
	}
})

// Methods
async function loadFriends()
{
	try{
		const { data } = await axios.get('/api/user-side/getUserFriendsWhoCompletedChallenge/' + props.challengeId)
		friends.value = data.list
		count.value = data.count
	} finally {
		loaded.value = true 
	}
}

// Lifecycle
onMounted(() => {
	loadFriends()
})
</script>
